// Цвета текстиля
export default {
  state: {
    // id - УНИК. идентификатор, label - название, hex - код цвета HTML hex
    'black': {
      id: 'black',
      label: 'Черный',
      hex: '#000000',
    },
    'burgundy': {
      id: 'burgundy',
      label: 'Бордовый',
      hex: '#9B2D30',
    },
    'chocolate': {
      id: 'chocolate',
      label: 'Шоколад',
      hex: '#5D4739',
    },
    'dark-green': {
      id: 'dark-green',
      label: 'Темно-зеленый',
      hex: '#3E5D57',
    },
    'fuchsia': {
      id: 'fuchsia',
      label: 'Фуксия',
      hex: '#D81983',
    },
    'cyan': {
      id: 'cyan',
      label: 'Голубой',
      hex: '#0082B8',
    },
    'mustard': {
      id: 'mustard',
      label: 'Горчица',
      hex: '#D89E54',
    },
    'green': {
      id: 'green',
      label: 'Зеленый',
      hex: '#018754',
    },
    'emerald': {
      id: 'emerald',
      label: 'Изумрудный',
      hex: '#73CBB3',
    },
    'jeans': {
      id: 'jeans',
      label: 'Джинс',
      hex: '#005F85',
    },
    'khaki': {
      id: 'khaki',
      label: 'Хаки',
      hex: '#757446',
    },
    'red': {
      id: 'red',
      label: 'Красный',
      hex: '#DA1F26',
    },
    'azure': {
      id: 'azure',
      label: 'Лазурь',
      hex: '#5D87DB',
    },
    'lime': {
      id: 'lime',
      label: 'Лайм',
      hex: '#A2D356',
    },
    'melange': {
      id: 'melange',
      label: 'Меланж',
      hex: '#B2A9AC',
    },
    'menthol': {
      id: 'menthol',
      label: 'Ментоловый',
      hex: '#92DBCA',
    },
    'sky': {
      id: 'sky',
      label: 'Небо',
      hex: '#99D2DB',
    },
    'orange': {
      id: 'orange',
      label: 'Оранжевый',
      hex: '#FE5900',
    },
    'peach': {
      id: 'peach',
      label: 'Персик',
      hex: '#FE8572',
    },
    'sand': {
      id: 'sand',
      label: 'Песок',
      hex: '#CDB986',
    },
    'gray': {
      id: 'gray',
      label: 'Серый',
      hex: '#919388',
    },
    'blue': {
      id: 'blue',
      label: 'Синий',
      hex: '#0A2F73',
    },
    'lilac': {
      id: 'lilac',
      label: 'Сирень',
      hex: '#999DCA',
    },
    'plum': {
      id: 'plum',
      label: 'Слива',
      hex: '#3D2B55',
    },
    'dark-blue': {
      id: 'dark-blue',
      label: 'Темно-синий',
      hex: '#222943',
    },
    'terracotta': {
      id: 'terracotta',
      label: 'Терракот',
      hex: '#885949',
    },
    'white': {
      id: 'white',
      label: 'Белый',
      hex: '#f5f5f5',
    },
    'yellow': {
      id: 'yellow',
      label: 'Желтый',
      hex: '#FFD101',
    },
    'cherry': {
      id: 'cherry',
      label: 'Вишня',
      hex: '#992020',
    },
    'anthracite': {
      id: 'anthracite',
      label: 'Антрацит',
      hex: '#343847',
    },
    'lettuce': {
      id: 'lettuce',
      label: 'Салатовый',
      hex: '#59D600',
    },
    'indigo': {
      id: 'indigo',
      label: 'Индиго',
      hex: '#3055A3',
    },
  }
}